import React from 'react';
import "../styles/global.css";

function BePrivateButton ({text, callback}) {

    const handleClick = () => {
        if (callback) {
            callback();
        }
      };

    return (
        <div className='be-private-button-container'>
           <button className='be-private-button' onClick={handleClick}>
            {text}
           </button>
        </div>
    );
};

export default BePrivateButton;